// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accord_group {
  margin-bottom: 5vh;
}
.accord_group .accord_item {
  --background: #baa599a1 !important;
  transition: all 0.3s ease-in-out;
  color: #fff3e7 !important;
  border-radius: 3px;
}
.accord_group .accord_item ion-label,
.accord_group .accord_item .item-native {
  color: #fff3e7 !important;
}
.accord_group .center_spinner {
  margin-bottom: 10vh;
}
.accord_group .no_set_data {
  text-align: center;
  font-size: 13px;
  margin: 0;
  margin-bottom: 2vh;
  color: #d4c4b9;
  font-weight: bold;
}
.accord_group .content {
  background: #fef9f2;
  border: 2px solid #ffefe4;
  border-top: none;
}
.accord_group .content .set_info {
  font-size: 10px;
  color: #8e8e8e;
  display: block;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
  text-align: center;
}
.accord_group .content .set_card_wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  grid-gap: 10px;
  justify-content: center;
}
.accord_group .content .set_card_wrap .set_card {
  width: 20%;
}
.accord_group .content .set_card_wrap .set_card img {
  width: 100%;
}
.accord_group .content .set_card_wrap .set_card .name {
  font-size: 8px;
  text-align: center;
  color: #3c3c3c;
  font-weight: bold;
}
.accord_group .content .set_card_wrap .set_card .number {
  font-size: 8px;
  text-align: center;
  color: #8e8e8e;
  font-weight: bold;
}
.accord_group .content .set_card_wrap .this_card {
  background: #e0ffde;
  padding: 4px;
}
.accord_group .content .set_card_wrap .this_card .name,
.accord_group .content .set_card_wrap .this_card .number {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/set-viewer/set-viewer.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kCAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACI;;EAEE,yBAAA;AACN;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAFJ;AAKE;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAHN;AAMI;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;AAJN;AAMM;EACE,UAAA;AAJR;AAMQ;EACE,WAAA;AAJV;AAOQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AALV;AAQQ;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AANV;AAUM;EACE,mBAAA;EACA,YAAA;AARR;AAUQ;;EAEE,YAAA;AARV","sourcesContent":[".accord_group {\n  margin-bottom: 5vh;\n\n  .accord_item {\n    --background: #baa599a1 !important;\n    transition: all 0.3s ease-in-out;\n    color: #fff3e7 !important;\n    border-radius: 3px;\n\n    ion-label,\n    .item-native {\n      color: #fff3e7 !important;\n    }\n  }\n\n  .center_spinner {\n    margin-bottom: 10vh;\n  }\n\n  .no_set_data {\n    text-align: center;\n    font-size: 13px;\n    margin: 0;\n    margin-bottom: 2vh;\n    color: #d4c4b9;\n    font-weight: bold;\n  }\n\n  .content {\n    background: #fef9f2;\n    border: 2px solid #ffefe4;\n    border-top: none;\n\n    .set_info {\n      font-size: 10px;\n      color: #8e8e8e;\n      display: block;\n      width: 100%;\n      margin-bottom: 20px;\n      margin-top: 10px;\n      text-align: center;\n    }\n\n    .set_card_wrap {\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n      grid-gap: 10px;\n      justify-content: center;\n\n      .set_card {\n        width: 20%;\n\n        img {\n          width: 100%;\n        }\n\n        .name {\n          font-size: 8px;\n          text-align: center;\n          color: #3c3c3c;\n          font-weight: bold;\n        }\n\n        .number {\n          font-size: 8px;\n          text-align: center;\n          color: #8e8e8e;\n          font-weight: bold;\n        }\n      }\n\n      .this_card {\n        background: #e0ffde;\n        padding: 4px;\n\n        .name,\n        .number {\n          color: black;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
